import React, { memo } from "react";
import MerchangdisingHistoryOrder from "../MerchangdisingHistoryOrder";
import LoyaltyHistoryOrder from "../LoyaltyHistoryOrder";
import NoneData from "components/NoneData";
import FormOrder from "../FormOrder";
import useStyles from "./styles";

import { useTheme } from "@material-ui/core/styles";
import { Grid, Button } from "@material-ui/core";
import { Images } from "config/images";

const menuHistory = [
	{
		type: "SALE",
		title: (
			<React.Fragment>
				Đơn hàng
				<br /> đã mua
			</React.Fragment>
		),
		icon: "icBought"
	},
	{
		type: "MERCHANDISING",
		title: "Trả trưng bày",
		icon: "icMerchangdisingReward"
	},
	{
		type: "LOYALTY",
		title: "Trả tích lũy",
		icon: "icLoyaltyReward"
	}
];

const MenuItem = memo(props => {
	const { icon, title, orderType, type, handleMenuSelected } = props;
	const classes = useStyles();
	const theme = useTheme();

	return (
		<Grid item xs={4}>
			<Button
				classes={{ root: classes.bgButton }}
				style={{
					border: `1.5px solid ${
						type === orderType
							? theme.palette.primary.main
							: theme.palette.common.white
					}`
				}}
				onClick={() => {
					handleMenuSelected(type);
				}}
			>
				<Grid>
					<img src={Images[`${icon}`]} alt={icon} />
					<Grid classes={{ root: classes.textButton }}>{title}</Grid>
				</Grid>
			</Button>
		</Grid>
	);
});

const BodyMenu = memo(props => {
	const {
		orderType,
		listOrder,
		isMobile,
		fetchListOrder,
		setMenuChildrenHistory,
		menuChildren,
		business,
		distanceToTop
	} = props;

	const height = `calc(100vh -${distanceToTop}px)`;

	switch (orderType) {
		case "SALE":
			return (
				<FormOrder
					listOrder={listOrder}
					isMobile={isMobile}
					fetchListOrder={fetchListOrder}
					setMenuChildrenHistory={setMenuChildrenHistory}
					menuChildren={menuChildren}
					business={business}
				/>
			);
		case "MERCHANDISING":
			return (
				<MerchangdisingHistoryOrder
					listOrder={listOrder}
					isMobile={isMobile}
					height={height}
				/>
			);
		case "LOYALTY":
			return (
				<LoyaltyHistoryOrder
					listOrder={listOrder}
					isMobile={isMobile}
					height={height}
				/>
			);
		default:
			return <NoneData />;
	}
});

const MenuHistoryOrder = props => {
	const {
		listOrder,
		isMobile,
		fetchListOrder,
		orderType,
		handleMenuSelected,
		setMenuChildrenHistory,
		menuChildren,
		business
	} = props;

	const divToScrollTo = document.getElementById("orderHistory");
	const distanceToTop = divToScrollTo?.offsetTop;

	return (
		<Grid>
			<Grid
				container
				spacing={2}
				style={{ padding: "5px 16px 1px 16px" }}
			>
				{menuHistory?.map((menu, index) => (
					<MenuItem
						key={index}
						icon={menu?.icon}
						title={menu?.title}
						orderType={orderType}
						type={menu?.type}
						handleMenuSelected={handleMenuSelected}
					/>
				))}
			</Grid>
			<Grid id="orderHistory" />
			<BodyMenu
				orderType={orderType}
				listOrder={listOrder}
				isMobile={isMobile}
				fetchListOrder={fetchListOrder}
				setMenuChildrenHistory={setMenuChildrenHistory}
				menuChildren={menuChildren}
				business={business}
				distanceToTop={distanceToTop}
			/>
		</Grid>
	);
};

export default memo(MenuHistoryOrder);
